// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3FAWo","load5":"Spinner_load5__2pKFp"};